import { clickedAnalytics } from '@bridebook/web/app-basic/lib/analytics/tracking-actions/clicked';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

export enum ClickedLocation {
  Awards = 'awards',
  Faq = 'faq',
  Gallery = 'dropdownMediaGallery',
}

export const useClickedSupplierAccordionAnalytics = (clickedSection: string) => {
  const dispatch = useDispatch();

  return useCallback(
    (isOpen: boolean) => {
      isOpen &&
        dispatch(
          clickedAnalytics({
            cta: 'View more',
            clickedSection,
            clickedLocation: 'supplierProfile',
          }),
        );
    },
    [dispatch, clickedSection],
  );
};
